import Delete from "assets/Icon_Action_03.png";
import Update from "assets/Icon_Action_02.png";
import View from "assets/Icon_Action_01.png";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { NCRCategoryRow } from "./NCRCategoryList.types";
import DeleteModal from "components/helpers/DeleteModal";
import { CrudItems, CrudOptions } from "components/Category/CrudMenu";
import { endpoints } from "config";

const NCRCategory = lazyWithRetry(() => import("pages/NCRCategory/NCRCategory/NCRCategory"));

// --- CRUD item creators ---

/**
 * Creates the create menu item for NCR categories
 * @returns CRUD item for creating a new NCR category
 */
function createNCRCategoryCreateItem() {
  return {
    icon: View,
    imgAltText: "Create",
    permissionsKey: "create",
    title: "Add new NCR category",
    menuCode: "CREATE" as CrudOptions,
    showInMultiSelect: false,
    content: (onDone: () => void, selectedData: NCRCategoryRow[], menu: any) => (
      <NCRCategory
        selectedData={selectedData}
        onDone={onDone}
        idFromRowOption={menu.selectedId}
        actionType="create"
        submitButtonText="Add"
      />
    ),
    inRightPanel: true,
    isDisabled: false,
    notInMenus: true,
  };
}

/**
 * Creates the update menu item for NCR categories
 * @returns CRUD item for updating an existing NCR category
 */
function createNCRCategoryUpdateItem() {
  return {
    icon: Update,
    imgAltText: "Update",
    permissionsKey: "edit",
    title: "Update NCR category",
    menuCode: "UPDATE" as CrudOptions,
    showInMultiSelect: false,
    content: (onDone: () => void, selectedData: NCRCategoryRow[], menu: any) => (
      <NCRCategory
        selectedData={selectedData}
        onDone={onDone}
        idFromRowOption={menu.selectedId}
        actionType="edit"
        submitButtonText="Update"
      />
    ),
    inRightPanel: true,
    isDisabled: false,
  };
}

/**
 * Creates the delete menu item for NCR categories
 * @returns CRUD item for deleting one or more NCR categories
 */
function createNCRCategoryDeleteItem() {
  return {
    icon: Delete,
    imgAltText: "Delete",
    permissionsKey: "delete",
    title: (data: NCRCategoryRow[]) =>
      data.length <= 1 ? "Delete NCR category" : `Delete ${data.length} NCR categories`,
    menuCode: "DELETE" as CrudOptions,
    showInMultiSelect: true,
    content: (onActionComplete: () => void, selectedData: NCRCategoryRow[], menu: any) => (
      <DeleteModal
        url={endpoints.ncrCategory.delete}
        noun="NCR category"
        selectedIds={selectedData.map((d) => d.ncrCategoryTypes__Id)}
        renderListItem={(data: NCRCategoryRow) => {
          return <li>{`${data.ncrCategoryTypes__Id}: ${data.ncrCategoryTypes__CategoryName}`}</li>;
        }}
        selectedData={selectedData}
        open={menu.currentMenu === "DELETE"}
        close={onActionComplete}
        idFromRowOption={menu.selectedId}
      />
    ),
    inRightPanel: false,
    isDisabled: false,
  };
}

/**
 * Gets all CRUD items for NCR categories
 * @returns Array of CRUD items for NCR category operations
 */
export function getCrudItems(): CrudItems<NCRCategoryRow> {
  return [
    createNCRCategoryCreateItem(),
    createNCRCategoryUpdateItem(),
    createNCRCategoryDeleteItem(),
  ];
}
